import React from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { HomeTabKeyEnum } from "../utils";

const StyledFooter = styled(Layout.Footer)`
	background: #001529;
	text-align: center;
	padding: 16px 24px;
	color: rgba(255, 255, 255, 0.65);
	font-size: 13px;

	.footer-links {
		margin-bottom: 8px;

		a {
			color: rgba(255, 255, 255, 0.85);
			text-decoration: none;
			margin: 0 12px;

			&:hover {
				color: #1890ff;
				text-decoration: underline;
			}
		}

		.separator {
			color: rgba(255, 255, 255, 0.35);
		}
	}

	.footer-notice {
		color: rgba(255, 255, 255, 0.45);
		font-size: 12px;
		margin-top: 4px;
	}
`;

const Footer: React.FC = () => {
	return (
		<StyledFooter>
			<div className="footer-links">
				<Link to={HomeTabKeyEnum.TERMS_OF_USE}>Terms of Use</Link>
				<span className="separator">|</span>
				<Link to={HomeTabKeyEnum.PRIVACY_POLICY}>Privacy Policy</Link>
			</div>
			<div>
				&copy; 2026 Marathon Ventures Media Sales. All rights reserved.
			</div>
			<div className="footer-notice">
				This is an internal site for Marathon Authorized Employees. All
				other use is prohibited.
			</div>
		</StyledFooter>
	);
};

export default Footer;
